export default {"src":"/_next/static/media/enablecookies.42d7b975.svg","height":301,"width":314,"blurWidth":0,"blurHeight":0};